Vue.component('ack-testimonial-card', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-testimonial-card',
  mounted() {
    appLog.log('ack-testimonial-card mounted')
    
    
    
  },
  props:{
    testimonial: {
      type: Object,
      required: true
    }
    
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    ratingText(){
      if(this.testimonial != null){
        switch(this.testimonial.rate){
          case 1:
            return '★'
          break;
          case 2:
            return '★★'
          break;
          case 3:
            return '★★★'
          break;
          case 4:
            return '★★★★'
          break;
          case 5:
            return '★★★★★'
          break;
        }
      }
      

      return '★★★★★'
    }
  },
  data() {
    return {

    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
    
    
    

  },
  beforeDestroy() {
    
  },
  watch: {
    
    testimonial: {
      handler() {
        
        
        
      },
      deep: false
    }
  }
})